module.exports = __webpack_public_path__ + "static/media/il.37eb709d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/il.svg
// module id = 2115
// module chunks = 0